<template functional>
        <div class="wrapper">
          <svg width="325" height="200">
            <path d="M155 20
               A 80 80, 0, 1, 1, 80 120
               L 155 100 Z" fill="#e5e7e9"/>
            <path d="M120 30
                A 80 80, 0, 0, 0, 80 120
               L 155 100 Z" fill="#ced1d5"/>
            <path d="M155 20
                A 80 80, 0, 0, 0, 120 30
                L 155 100 Z" fill="#b9bdc3"/>
            <circle cx="157" cy="100" r="35" fill="white" />
            </svg>
          <div class="description">
            No comparison sites entered into system
          </div>
          </div>
</template>

<script>
  import Overview from "../rank-zone/overview/Overview"

  /**
   * Placeholder for Comparison block on {@link Overview} page
   */
  export default {
    name: 'OverviewComparisonPlaceholder'
  }

</script>

<style scoped>
  .wrapper {
    margin: 35px auto 0;
  }

  .description {
    font-size: 14px;
    color: #777777;
    font-weight: bold;
    letter-spacing: -0.16px;
    text-align: center;
  }
</style>
